"use client";

export function NarrativeBlock({ text }: { text: string }) {
  return (
    <div className="bg-surface-light/5 border border-surface-light/10 rounded-xl p-5 mb-5">
      <div className="flex items-center gap-2 mb-2">
        <span className="text-[10px] font-semibold uppercase tracking-wide bg-blue/15 text-blue px-2 py-0.5 rounded">
          Simple English
        </span>
      </div>
      <p className="text-sm leading-relaxed text-foreground/90 whitespace-pre-line">{text}</p>
    </div>
  );
}
